import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const getSectionItemsBySection = async (sectionId) => {
  const response = await axiosInstance.get(
    `content-section-items/get-by-section/${sectionId}`,
    { headers }
  );
  return response.data?.result ?? response.data ?? [];
};

export const bulkAddSectionItems = async (payload) => {
  return await axiosInstance.post("content-section-items/bulk-add", payload, {
    headers,
  });
};

export const reorderSectionItems = async (payload) => {
  return await axiosInstance.put("content-section-items/reorder", payload, {
    headers,
  });
};

export const deleteSectionItem = async (id) => {
  return await axiosInstance.delete(
    `content-section-items/delete/${id}`,
    { headers }
  );
};
